export default __webpack_public_path__ + "static/media/LOGOS4.418ac216.jpg";